<script setup>
import { storeToRefs } from 'pinia'
import { useCharityStore } from '@/stores/charity'
import { useDonationStore } from '@/stores/donation'
import { computed, onMounted } from 'vue'
import useLaunchDarkly from '@/composables/launch-darkly'
import { useHead } from '@unhead/vue'

const charity = useCharityStore()
const donationStore = useDonationStore()

const { getCharityInfo } = storeToRefs(charity)
const { updateLaunchDarklyContext, registerLaunchDarklyWatcher, setupLaunchDarkly } =
  useLaunchDarkly()

const siteName = computed(() => {
  return getCharityInfo.value ? getCharityInfo.value.charity_name : ''
})

useHead({
  // The long-winded way of saying the title should be "Page Title | Charity Name"
  titleTemplate: (title) => [title, siteName.value].filter((v) => !!v).join(' | ')
})

registerLaunchDarklyWatcher()

onMounted(() => {
  setupLaunchDarkly()

  // Update user context if charity data is loaded and available
  if (getCharityInfo.value) {
    updateLaunchDarklyContext()
  }

  window.addEventListener('beforeunload', () => {
    charity.setCharityInfo(null)
    donationStore.setConfig(null)
  })
})
</script>

<template>
  <router-view />
</template>

<style lang="scss">
/* route transition */
.route-enter-from {
  opacity: 0;
  transform: translateX(-100px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}
.route-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.4s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(100px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
